import ApplicationComponent from "legacy/ApplicationComponent"
import PropTypes from "prop-types"
import React from "react"

/**
 * WarningAlert is a component that renders content within a yellow alert
 * @param {(function|function[])} children - The contents to be rendered inside the alert.
 */

class WarningAlert extends ApplicationComponent {
  render() {
    const { children } = this.props

    return (
      <div className="reports-alert">
        <div
          className="alert alert-warning font-weight-400 text-gray-900"
          style={{ marginBottom: "16px" }}
        >
          <i
            className="fa-kit fa-exclamation-circle-fa"
            style={{ marginRight: "16px", fontSize: "16px" }}
          />
          {children}
        </div>
      </div>
    )
  }
}

WarningAlert.propTypes = {
  children: PropTypes.node,
}

export default WarningAlert
